module.exports = __webpack_public_path__ + "media/customizations/fsr/logo-663986a98841159b597bf81a94d88cd7.png";